
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/straps/[material]/[sku]",
      function () {
        return require("private-next-pages/[lang]/straps/[material]/[sku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/straps/[material]/[sku]"])
      });
    }
  